import { Controller } from 'front-end-core/core/Router'
import { combineLatest, merge } from 'rxjs'
import { takeUntil, skip, debounceTime } from 'rxjs/operators'
import {
  UserInteraction,
  RenderNotification,
  MouseWheel
} from 'front-end-core/services/WindowService'
import { scrollTo } from 'front-end-core/helpers/document'
import getUrl from 'front-end-core/core/url'
import Header from './Header'
import Main from './Main'
import { LEGISLATION } from 'constants/controllers'
import { Media } from 'services/WindowService'

export default new Controller({
  name: LEGISLATION,
  route: ':aol/(:archive/)legislation/*path(/edit/:editingId)',
  controller (
    Router,
    {
      url,
      scrollMain,
      pageView,
      pageData,
      params: { aol, path = null, editingId = null },
      previousPageId,
      query
    },
    render
  ) {
    const [act] = (path && path.split(':')) || []
    const pageId = getUrl(LEGISLATION, { aol, path: act, editingId })
    const scrollTarget = query.comment

    render(
      { Header, Main },
      { aol, act: path, scrollMain, editingId, highlight: `#${url}` },
      {
        act: path,
        pageId,
        searchType: 'legislation',
        className: 'legislation',
        aol
      }
    )

    if (scrollMain !== null || path) {
      combineLatest(
        [Media.Mobile,
          RenderNotification.pipe(debounceTime(5))]
      )
        .pipe(takeUntil(merge(UserInteraction, MouseWheel), skip(1)))
        .subscribe(([isMobile]) => {
          if (scrollMain) {
            scrollTo({ pageId, id: scrollMain, useWindowScrollTo: isMobile })
          } else if (scrollTarget) {
            scrollTo({ pageId, id: scrollTarget, useWindowScrollTo: isMobile })
          } else if (path && path.split(':::::').length !== 2) { // disable scroll when at top level
            scrollTo({ pageId, id: getUrl(LEGISLATION, { aol, path }), useWindowScrollTo: isMobile })
          }
        })
    }

    return pageId
  }
})
